import './ContributionManagmentView.scss';
// @vendors
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
const { withRouter } = require('react-router-dom');
// @helpers
import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;
// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('commonsComponents/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const PaginationButtons = require('components/commons/paginationButtons/paginationButtons');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { ContentBox } = require('commonsComponents/contentBox');

//@utils
const { recordPage, PROC_BROKER_INVESTMENT_CONTRIBUTIONS } = require('utilities/tagging.js');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @components
import ContributionManagmentTable from './components/ContributionManagmentTable/ContributionManagmentTable';
// @ actions
import BrokerPeriodicalFundsContributionsActions from 'actions/brokerPeriodicalFundsContributions';
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');

const ContributionManagmentView = ({
  immBrokerPeriodicalFundsContributions,
  immBrokerMyInvestments,
  fetchPeriodicalContributions,
  changePage,
  history,
  immProfile,
  fetchMyInvestments
}) => {
  useEffect(() => {
    fetchPeriodicalContributions();
  }, [immBrokerMyInvestments.get('fetchSuccess')]);

  useEffect(() => {
    if (immBrokerPeriodicalFundsContributions.get('periodicalFundsContributions').size > 0) {
      const periodicalFundsContributions = immBrokerPeriodicalFundsContributions.get(
        'periodicalFundsContributions'
      );
      const contributionList = periodicalFundsContributions.toJS().flat();
      const clientCode = immProfile.getIn(['codigoPersona', 'f']);
      const customData = {
        nombrePagina: 'gestion aportaciones robo',
        tipoProceso: 'proc-gestion-aportaciones-robo',
        tipoPagina: 'generica',
        zonaWeb: 'zona privada',
        tipoUsusario: 'cliente',
        estadoUsuario: 'logado',
        identificadorUsuario: clientCode,
        tealium_event: 'product_impression',
        product_impression_name: contributionList.map(c => c.marketName),
        product_impression_id: contributionList.map(c => c.isin),
        product_impression_list: contributionList.map(c => c.marketName),
        product_impression_position: contributionList.map((c, i) => i + 1),
      };

      recordPage(customData);
    }
  }, [immBrokerPeriodicalFundsContributions.get('periodicalFundsContributions')]);

  const getBreadcrumbData = () => {
    return [
      {
        text: formatText('breadcrumbWealth-contributionManagment'),
      },
      {
        text: formatText('breadcrumbWealth-contributionManagment'),
      },
    ];
  };

  const buildFetching = () => {
    return (
      <OKSectionBox>
        <LoadingSection />
      </OKSectionBox>
    );
  };

  const buildContent = () => {
    return (
      <div className="grid-view__body">
        <div className="container-fluid">
          <div className="row grid-view--content-position-negative">
            <div className="col-xs-12">
              {fetched && (
                <OKSectionBox
                  title={formatText('brokerWealth-contributionManagmentSubTitle')}
                  className="broker-contribution-managment-view"
                >
                  <ContributionManagmentTable
                    periodicalFundsContributions={periodicalContributionData[index]}
                    expandRowId={expandRowId}
                  />
                  {totalPages >= 2 && (
                    <PaginationButtons
                      totalPages={totalPages}
                      callbackFunction={e => changePage(e)}
                      pageNumber={actualPage}
                    />
                  )}
                </OKSectionBox>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const buildRetry = () => {
    const lostConnectionFirstLine = formatText('broker-lostConnectionFirstLine');
    const errorPg = immBrokerMyInvestments.get('errorReceived')
    const retryButton = (
        <OKButton onClick={() => {
            errorPg ? fetchMyInvestments() : fetchPeriodicalContributions();
        }}>
            <FormattedText value="broker-retry" />
        </OKButton>
    );
    return (
      <ContentBox>
        <EmptyState
          button={retryButton}
          primaryText={lostConnectionFirstLine}
          iconType="nointernet-wealth"
        />
      </ContentBox>
    );
  };

  const mappingBreadcrumb = getBreadcrumbData();
  const periodicalFundsContributions = immBrokerPeriodicalFundsContributions.get(
    'periodicalFundsContributions'
  );
  const actualPage = immBrokerPeriodicalFundsContributions.get('actualPage');
  const index = actualPage - 1;
  const totalPages = immBrokerPeriodicalFundsContributions.get('totalPages');
  const periodicalContributionData = periodicalFundsContributions.toJS();
  const fetched = immBrokerPeriodicalFundsContributions.get('fetched');
  const expandRowId = immBrokerPeriodicalFundsContributions.get('expandRowId');
  const fetching = immBrokerPeriodicalFundsContributions.get('fetching');
  const errorPg = immBrokerMyInvestments.get('errorReceived')
  const fetchingPG = immBrokerMyInvestments.get('isFetching');
  const errorList = immBrokerPeriodicalFundsContributions.get('error');

  const handleClickGoInvestment = () => {
    taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'myInvestementButton');
    history.push('/myprofile/broker/investment');
  };
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <OKCover size="medium" section="broker" customClass="col-xs-12">
            <BrokerTruncatedBreadcrumb
              titleKey={formatText('brokerWealth-contributionManagmentTitle')}
              breadcrumbConfig={mappingBreadcrumb}
            >
              <OKButton inverse={true} modifier="ghost" onClick={handleClickGoInvestment}>
                <FormattedText value={'brokerWealth-contributionManagmentBreadCrumbButtonText'} />
              </OKButton>
            </BrokerTruncatedBreadcrumb>
          </OKCover>
        </div>
      </div>
      {fetching || fetchingPG ? buildFetching() : ( errorPg || errorList ? buildRetry() : buildContent())}
    </div>
  );
};

ContributionManagmentView.propTypes = {
  immBrokerPeriodicalFundsContributions: PropTypes.object.isRequired,
  fetchPeriodicalContributions: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    immBrokerPeriodicalFundsContributions: state.brokerPeriodicalFundsContributions,
    immBrokerMyInvestments: state.brokerMyInvestments,
    immProfile: state.profile,
  }),
  {
    fetchPeriodicalContributions:
      BrokerPeriodicalFundsContributionsActions.fetchPeriodicalContributions,
    changePage: BrokerPeriodicalFundsContributionsActions.changePage,
    fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments
  }
)(withRouter(ContributionManagmentView));
